import {useLivraisonsPossiblesContext} from 'ff-common';
import {useNavigate} from 'react-router-dom';
import {useClientRoute} from '../auth/useClientRoute';
import {routes} from 'ff-common';
import {useLivraisons} from '@/haligator-factory';
import {useHalStates} from '@synako/haligator';

export const useAfficherCadencier = () => {
  const {setLivraisonSelectionnee} = useLivraisonsPossiblesContext();
  const navigate = useNavigate();
  const {buildClientRoute} = useClientRoute();
  const livraisonsPossibles = useHalStates(useLivraisons().followAll('items'));

  const afficherCadencier = (dateLivraison: string) => {
    const state = livraisonsPossibles.states?.find(
      (livraison) => livraison.data.tolede.date_de_livraison === dateLivraison,
    );
    if (state) {
      setLivraisonSelectionnee(state);
    }
    navigate(buildClientRoute(routes.client.cadencier));
  };

  return afficherCadencier;
};
